import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DocumentCategory } from '../models/document.interface';

export interface Carousel {
  id: number;
  title: string | null;
  subtitle: string | null;
  description: string | null;
  button_text: string;
  link: string | null;
  image_url: string;
  is_external: boolean;
  is_active: boolean;
  order: number;
}

export interface BannerNews {
  id: number;
  type: string;
  content: string;
  link: string | null;
  alt_text: string | null;
  is_active: boolean;
  order: number;
}

export interface Service {
  id: number;
  title: string;
  description: string;
  icon: string | null;
  features: string[] | null;
  is_active: boolean;
  order: number;
}

export interface About {
  id: number;
  title: string;
  content: string;
  image_url: string | null;
  video_url: string | null;
  button_text: string | null;
  button_link: string | null;
  is_active: boolean;
}

export interface News {
  id: number;
  title: string;
  summary: string;
  content: string;
  image_url: string | null;
  author: string | null;
  date: string;
  views: number;
  tags: string[];
  category_id: number | null;
  is_active: boolean;
}

export interface Event {
  id: number;
  title: string;
  description: string;
  date_start: string;
  date_end: string | null;
  registration_deadline: string | null;
  location: string | null;
  organizer: string | null;
  image_url: string | null;
  link: string | null;
  price: number;
  max_attendees: number | null;
  current_attendees: number;
  tags: string[];
  category_id: number | null;
  is_active: boolean;
}

export interface Contact {
  id: number;
  address: string | null;
  phone: string | null;
  email: string | null;
  facebook: string | null;
  twitter: string | null;
  instagram: string | null;
  linkedin: string | null;
  map_url: string | null;
  is_active: boolean;
}

export interface HomeDataResponse {
  carousels: Carousel[];
  banner_news: BannerNews[];
  services: Service[];
  about: About[];
  news: News[];
  events: Event[];
  contact: Contact[];
  transparency_categories?: DocumentCategory[];
}


@Injectable({
  providedIn: 'root'
})
export class HomeDataService {
  private http = inject(HttpClient);
  // Defaulting to the new API endpoint for home data
  private apiUrl = `${environment.apis.base}/home/data`;

  getHomeData(): Observable<HomeDataResponse> {
    return this.http.get<HomeDataResponse>(this.apiUrl);
  }
}

